import {IdTypeEnum} from './cartDetails/idType.enum';

abstract class AbstractCustomerDetails {
  public firstName: string;
  public lastName: string;
  public pesel: string;
  public documentNo: string;
  public idExpiryDate: string;
  public contractPassword: string;
  public companyName: string;
  public nip: string;
  public regon: string;
  public legalizeDate: string;
  public email: string;
  public phone: string;
  public contractAddress: Address;
  public correspondenceAddress: Address;
  public idCardType: IdTypeEnum;

  protected constructor(customerDetails: any = {}) {
    this.firstName = customerDetails.firstName || '';
    this.lastName = customerDetails.lastName || '';
    this.pesel = customerDetails.customerCode || '';
    this.documentNo = customerDetails.idSeriesNumber || '';
    this.idExpiryDate = customerDetails.idExpiryDate || '';
    this.contractPassword = customerDetails.passwordForContract || '';
    this.companyName = customerDetails.companyName || '';
    this.nip = customerDetails.nip || '';
    this.regon = customerDetails.regon || '';
    this.legalizeDate = customerDetails.legalizeDate || ''; // lub legalizeDate tj. nazwa inputa
    this.email = customerDetails.customerEmail || '';
    this.phone = customerDetails.customerPhone || '';
    this.idCardType = customerDetails.idCardType || '';
    this.contractAddress = new Address(customerDetails.contractAddress);
    this.correspondenceAddress = new Address(customerDetails.correspondenceAddress);
  }

  public getJoinContractAddressForView(): string {
    if (!this.contractAddress) {
      return '';
    }

    const contractApartment = this.contractAddress.apartmentNumber ?
      '/' + this.contractAddress.apartmentNumber :
      '';

    const contractProvince = this.contractAddress.province ? `, WOJ. ${this.contractAddress.province.toUpperCase()}` : '';

    // Example:
    // ul. Katowicka 55/5 45-061, Opole, WOJ.OPOLSKIE
    // or
    // ul. Katowicka 55 45-061, Opole, WOJ.OPOLSKIE
    return `${this.contractAddress.street} ${this.contractAddress.houseNumber}${contractApartment} ${this.contractAddress.postalCode} ${this.contractAddress.city} ${contractProvince}`;
  }

  public getJoinCorrespondenceAddressForView(): string {
    if (!this.correspondenceAddress) {
      return '';
    }

    const correspondenceApartment = this.correspondenceAddress.apartmentNumber ?
      '/' + this.correspondenceAddress.apartmentNumber :
      '';

    const correspondenceProvince = this.contractAddress.province ? `, WOJ. ${this.contractAddress.province.toUpperCase()}` : '';
    // Example:
    // ul. Katowicka 55/5 45-061 Opole, WOJ.OPOLSKIE
    // or
    // ul. Katowicka 55 45-061 Opole, WOJ.OPOLSKIE
    return `${this.correspondenceAddress.street} ${this.correspondenceAddress.houseNumber}${correspondenceApartment} ${this.correspondenceAddress.postalCode} ${this.correspondenceAddress.city} ${correspondenceProvince}`;
  }
}

class Address {
  public street: string;
  public houseNumber: string;
  public apartmentNumber: string;
  public postalCode: string;
  public city: string;
  public province: string;

  constructor(contractAddress: any = {}) {
    this.street = contractAddress.streetname || '';
    this.houseNumber = contractAddress.streetnumber || '';
    this.apartmentNumber = contractAddress.appartment || '';
    this.postalCode = contractAddress.postalcode || '';
    this.city = contractAddress.town || '';
    this.province = contractAddress.province || '';
  }
}

export class CustomerDetailsModel extends AbstractCustomerDetails {
  constructor(customerDetails: any = {}) {
    super(customerDetails);
  }
}

export class CustomerDetailsByProcess extends AbstractCustomerDetails {
  private static instance: CustomerDetailsByProcess;

  constructor(consumerDetails: any = {}) {
    super(consumerDetails);

    if (CustomerDetailsByProcess.instance) {
      return CustomerDetailsByProcess.instance;
    }

    CustomerDetailsByProcess.instance = this;
  }
}
